<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import URL from '@/views/mis/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import download from '@/utils/download'
  let userType = {"real":"真实","demo":"模拟"};
  let levelType = {"mMIN":"迷你","mSTD":"标准","mVIP":"金钻"};
  let isInviteCode = {1:"未使用邀请码",2:"有使用邀请码"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM
    },
    created(){
        this.formData.cols = [
            {title: window.$t('mis.tracker.isInviteCode'), field: 'isInviteCode', type: 2, optionList: isInviteCode},
            {title: window.$t('mis.tracker.inviteCode'),field: 'inviteCode'},
            { title: window.$t('mis.tracker.customerNo'), field: 'customerNo'},
            { title: window.$t('mis.common.phone'), field: 'phone'},
            { title: window.$t('mis.tracker.openStartTime'), field: 'openStartTime',type:5},
            { title: window.$t('mis.tracker.openEndTime'), field: 'openEndTime',type:5},
            { title: window.$t('mis.tracker.activeStartTime'), field: 'activeStartTime',type:5},
            { title: window.$t('mis.tracker.activeEndTime'), field: 'activeEndTime',type:5},
            { title: window.$t('mis.tracker.userType'), field: 'userType',type:2,optionList:userType},
            { title: window.$t('mis.tracker.isActive'), field: 'isActive',type:2,optionList:{"1":"激活","0":"未激活"}},
            {click: window.$t('mis.bt.search')},
            {click: window.$t('mis.bt.down')},
            {click: window.$t('mis.bt.export')},
            {click: window.$t('mis.tracker.isShow')},
        ];
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('mis.bt.search') == clickName){
          let param = JSON.parse(JSON.stringify(data));
          if (param.customerNo || param.phone) {
              param.openStartTime = "";
              param.openEndTime = "";
              param.activeStartTime = "";
              param.activeOpenTime = "";
          }
          this.queryData = param;
          this.$refs.childTable.defaultGetData(param);
        }else if(window.$t('mis.tracker.isShow') == clickName){
            this.pageData.isShow = !this.pageData.isShow;
        }else if(window.$t('mis.bt.down') == clickName){
            //隐藏关键字段
            const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
            download.exportExcel(URL.tracker.export,param,window.$t('mis.tracker.tracker'));
        }else if(window.$t('mis.bt.export') == clickName){
            const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
            download.exportExcel(URL.tracker.export,param,window.$t('mis.tracker.tracker'));
        }
      },
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[]
        },
        /*table生成*/
        pageData: {
          isShow: false,
          queryUrl: URL.tracker.query, //请求路径和参数
          sequence: true,
          cols: [
            {title: window.$t('mis.tracker.businessType'), field: 'businessType'},
            {title: window.$t('mis.tracker.customerNo'), field: 'customerNo'},
            {title: window.$t('mis.tracker.relatedAccount'), field: 'relatedAccount'},
            {title: window.$t('mis.common.name'), field: 'userName'},
            {title: window.$t('mis.tracker.userType'), field: 'userType',render:(data)=>{return userType[data];}},
            {title: window.$t('mis.tracker.levelType'), field: 'levelType',render:(data)=>{return levelType[data];}},
            {title: window.$t('mis.common.phone'), field: 'phone'},
            {title: window.$t('mis.common.email'), field: 'email'},
            {title: window.$t('mis.common.idNumber'), field: 'idCard'},
            {title: window.$t('mis.tracker.userAge'),field: 'userAge'},
            {title: window.$t('mis.tracker.gender'),field: 'gender'},
            {title: window.$t('mis.tracker.birthday'),field: 'birthday'},
            {title: window.$t('mis.tracker.ctime'),field: 'ctime',render:(data)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
            }},
            {title: window.$t('mis.tracker.pkey'),field: 'paySwitchFlowTagCode'},
            {title: window.$t('mis.tracker.nkey'),field: 'paySwitchSeqTagCode'},
            {title: window.$t('mis.tracker.creditLevel'), field: 'creditLevel'},
            {title: window.$t('mis.starLevel.starLevel'), field: 'starLevel'},
            {title: window.$t('mis.tracker.href'), field: 'href'},
            {title: window.$t('mis.tracker.utmSource'), field: 'utmSource'},
            {title: window.$t('mis.tracker.utmMedium'), field: 'utmMedium'},
            {title: window.$t('mis.tracker.utmCampaign'), field: 'utmCampaign'},
            {title: window.$t('mis.tracker.utmContent'), field: 'utmContent'},
            {title: window.$t('mis.tracker.utmTerm'), field: 'utmTerm'},
            {title: window.$t('mis.tracker.activeTime'),field: 'activeTime',render:(data)=>{
                    return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
            {title: "ip", field: 'ip'},
            {title: window.$t('mis.tracker.ipAddress'),field:'ipAddress'},
            {title: window.$t('mis.tracker.userAgent'),field:'userAgent'},
            {title: window.$t('mis.common.remark'),field:'remark'},
            {title: window.$t('mis.tracker.checkStatus'),field:'checkStatus',"render":(data)=>{
                    if(data==1) return "已验证";
                    if(data==0) return "未验证";
                    return "未验证";
                }},
            {title: window.$t('mis.tracker.arbitrageurTags'),field: 'arbitrageurTags'},
            {title: window.$t('mis.tracker.directAccount'),field: 'directAccount'},
            {title: window.$t('mis.tracker.directPhone'),field:'directPhone'},
            {title: window.$t('mis.tracker.directInviteCode'), field: 'inviteCode'}
        ]
        }
      }
    }
  }
</script>
